// Converted to typescript through help of ChatGPT
import type RootState from 'app-components/utils/redux-store/rootState';
import { Map as ImmutableMap } from 'immutable';
import { LruObjectCache, createCachedSelector } from 're-reselect';

import { selectorsHelpers } from '../core';
import { DOCUMENTS_REDUCER_KEY, Document, DocumentProps } from './documentsTypes';

// Constants
export const MAX_TX_ATTACHMENTS = 5;
type State = Pick<RootState, typeof DOCUMENTS_REDUCER_KEY>;

// Selectors
export const getDocumentsStore = (state: State) => state[DOCUMENTS_REDUCER_KEY];
export const getLastSyncDate = (state: State) => getDocumentsStore(state).lastSyncDate;

export const getDocuments = (state: State): ImmutableMap<string, Document> => {
  const newState = getDocumentsStore(state);
  return newState.resourcesById;
};

export function getDocumentById(state: State, id: string): DocumentProps | null {
  const documentsMap = getDocuments(state);
  return (
    Array.from(documentsMap.values()).find((document: DocumentProps) => String(document.id) === String(id)) || null
  );
}

export const getDocumentsForIds = createCachedSelector(
  [getDocuments, (state: State, ids: string[]) => ids],
  (documentsMap, ids) =>
    Array.from(documentsMap.values()).filter(
      (document: DocumentProps) => document.id && ids.includes(document.id as string),
    ),
)({
  keySelector: (state: State, ids: string[]) => ids?.join(',') || 'none',
  cacheObject: new LruObjectCache({ cacheSize: 5 }),
});

export const getDocumentsForAttachments = createCachedSelector(
  getDocuments,
  (state: State, attachments: { id: string; clientId: string }[]) => attachments,
  selectorsHelpers.createValueCache(
    (documentsMap: ImmutableMap<string, Document>, attachments: { id: string; clientId: string }[]) =>
      Array.from(documentsMap.values()).filter((document: Document) =>
        attachments?.find((attachment) => attachment.id === document.id || attachment.clientId === document.clientId),
      ),
  ),
)({
  keySelector: (state: State, attachments: { id: string; clientId: string }[]) =>
    attachments?.map((attachment) => attachment.id || attachment.clientId).join(',') || 'none',
  cacheObject: new LruObjectCache({ cacheSize: 5 }),
});
